<template>
    <pc-label
        v-bind:show-required="field.IsRequired"
        v-bind:label="field.DisplayName">
        <span class="fst-italic"> {{ inputFieldLabel }} </span>
    </pc-label>
    <pc-input
        v-for="(_, index) in field.MultiInstanceValues"
        v-bind:key="`inputValue${field.PublicId}_${index}`"
        v-model="field.MultiInstanceValues[index]"
        class="mb-3"
        v-bind:placeholder="multiInstanceElementPlaceholder"
        v-bind:validator="fieldValidator"
        v-bind:data-test-role="`testRole.field.${field.DisplayName}_${index}`"
        v-bind:required="field.IsRequired"
        v-on:validated="onValidated(index, $event)" />
    <pc-button-row class="mb-3">
        <pc-button
            primary
            v-on:click="addElement(index)">
            {{ addElementButtonLabel }}
        </pc-button>
        <pc-button
            secondary
            v-bind:disabled="removeButtonDisabled"
            v-on:click="removeElement">
            {{ removeElementButtonLabel }}
        </pc-button>
    </pc-button-row>
</template>

<script setup>
    import { computed } from "vue";
    import { useResource } from "Util/i18n";
    import { KEYS, NAMESPACE } from "./i18n/testConnectionMultiInstanceRequestField.i18n";
    import { KEYS as TEST_CONNECTION_KEYS, NAMESPACE as TEST_CONNECTION_NAMESPACE } from "../i18n/testConnection.i18n";

    defineProps({
        inputFieldLabel: { type: String, required: true },
        fieldValidator: { type: Object, required: true }
    });

    const field = defineModel({
        type: Object,
        required: true
    });

    const removeButtonDisabled = computed(() => field.value.MultiInstanceValues.length < 2);

    const { addElementButtonLabel, removeElementButtonLabel } = useResource(KEYS, NAMESPACE);

    const { multiInstanceElementPlaceholder } = useResource(TEST_CONNECTION_KEYS, TEST_CONNECTION_NAMESPACE);

    function addElement() {
        field.value.MultiInstanceValues.push("");
    }

    const emit = defineEmits(["validated", "elementRemoved"]);

    function onValidated(index, result) {
        emit("validated", `inputValue${field.value.PublicId}_${index}`, result);
    }

    function removeElement() {
        const indexToRemove = field.value.MultiInstanceValues.length - 1;
        field.value.MultiInstanceValues.pop();
        emit("elementRemoved", `inputValue${field.value.PublicId}_${indexToRemove}`);
    }
</script>
